import { useMemo } from 'react'

import useMediaQuery from '../../../hooks/useMediaQuery'
import useScrollDirection from '../../../hooks/useScrollDirection'
import { useActiveItem, useIsMobileMenuOpen, useShowSearch } from '../state'

export function useShouldHideHeader() {
  const showSearch = useShowSearch()
  const activeItem = useActiveItem()
  const isMobileMenuOpen = useIsMobileMenuOpen()
  const isDesktop = useMediaQuery('(min-width: 1024px)')
  const isTablet = useMediaQuery('(min-width: 768px)')

  const scrollThreshold = useMemo(() => {
    if (isDesktop) return 101
    if (isTablet) return 80
    return 60
  }, [isDesktop, isTablet])

  const scrollDirection = useScrollDirection(scrollThreshold)

  return useMemo(() => {
    if (showSearch || scrollDirection !== 'down') {
      return false
    }

    return isDesktop || isTablet ? !activeItem : !isMobileMenuOpen
  }, [showSearch, activeItem, isMobileMenuOpen, scrollDirection, isDesktop, isTablet])
}
